import { SocialMediaType } from '@/helpers/enumsTypes';
import { ResourceString } from '@/reducers/common/commonTypes';

export type SignupDefaultFields = {
  firstName: string;
  lastName: string;
  preferredName: string;
  email: string;
  password: string;
  socialMediaId: string;
  receiveEmailNotification: boolean;
  dob: string;
  type: string;
  picture: string;
  keepLoggedIn: boolean;
};

export type SocialFormField = {
  firstname: string;
  lastname: string;
  email: string;
  socialMediaId: string;
  dob: string;
  type: SocialMediaType;
  picture: string;
  password: string;
  keepLoggedIn: boolean;
  photo: string;
};

export type FormValidationRule = {
  key: string;
  value: string;
  message: string;
};

export const defaultFields: SignupDefaultFields = {
  firstName: '',
  lastName: '',
  preferredName: '',
  email: '',
  password: '',
  socialMediaId: '',
  receiveEmailNotification: false,
  dob: '',
  type: '',
  picture: '',
  keepLoggedIn: false,
};

export const defaultSocialFormField: SocialFormField = {
  firstname: '',
  lastname: '',
  email: '',
  socialMediaId: '',
  dob: '',
  type: SocialMediaType.Empty,
  picture: '',
  password: '',
  keepLoggedIn: false,
  photo: '',
};

export const formFieldErrorMessages: ResourceString = {
  firstname: 'As our primary sailor, we need you to provide a valid first name.',
  preferredname: 'We need you to provide a valid preferred name.',
  lastname: 'As our primary sailor, we need you to provide a valid last name.',
  email: 'We need you to provide a valid email address.',
  password:
    'Gotta be digitally secure. The password needs to be 8 to 50 characters long and contain at least 1 capital, 1 special character and 1 number.',
};

export const formValidation: FormValidationRule[] = [
  {
    key: 'firstname',
    value: '^[a-zA-Z\\-\\s\\,\\x27]{1,15}$',
    message: formFieldErrorMessages.firstname,
  },
  {
    key: 'lastname',
    value: '^[a-zA-Z\\-\\s\\,\\x27]{1,20}$',
    message: formFieldErrorMessages.lastname,
  },
  {
    key: 'preferredname',
    value: '^[a-zA-Z\\-\\s\\,\\x27]{0,40}$',
    message: formFieldErrorMessages.preferredname,
  },
  {
    key: 'email',
    value: '^[a-zA-Z0-9](?!.*?\\.\\.)[a-zA-Z0-9-_\\.]+@([a-zA-Z0-9_\\-.]+){2}\\.([a-zA-Z]{2,63})$',
    message: formFieldErrorMessages.email,
  },
  {
    key: 'password',
    value: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[\\_\\W])(?=.{8,50}$)[^\\s]+',
    message: formFieldErrorMessages.password,
  },
];
